import React, { useState, useEffect } from 'react'
import './NFT-card.css'




const NFTCard = ({ title, image, open, generating, paid, link, zero }) => {

    const [numberup, setNumberup] = useState(0)

    useEffect( () => {
		
			
            const interval = setInterval(() => {
                setNumberup( numberup + 0.01 );
              }, 1000);
              return () => clearInterval(interval);
           
	
	}, [numberup] );

	return (
		<div className="card-ctn">
            <div className="card-title">{title}</div>
            <div className="card-deets">
                <div className="card-image-ctn">
                    <img src={image} alt="NFT" />
                    <div className="card-detail-labels">
                        <span>Open streams</span>
                        <span>Monthly Revenue</span>
                        <span>LTD Earnings</span>
                        <span>Link</span>
                    </div>
                </div>
                <div className="card-detail-values">
                    <span>{open}</span>
                    <span>{generating}</span>
                    <span>${zero ? 0 : (paid + numberup).toFixed(2)}</span>
                    <span>{link}</span>
                </div>
            </div>
            <div className="card-btn-ctn">
                    <div className="transfer-btn">Sell NFT</div>
                    <div className="copy-btn">Copy Link</div>
            </div>
		</div>
	)
}

export default NFTCard

